
import dust from "dustjs-linkedin";


(function(){dust.register("widgets/switch",body_0);function body_0(chk,ctx){return chk.write("<div class=\"switch ").reference(ctx.get(["switchClass"], false),ctx,"h").write(" ").exists(ctx.get(["on"], false),ctx,{"block":body_1},{}).write("\"><div class=\"slide\"></div><div class=\"slider\"></div></div>");}function body_1(chk,ctx){return chk.write("on");}return body_0;})();

export default 0;
